export default "__VITE_ASSET__VOxNeT6h__ 194w";